export const getters = { 
  items: state => state.items,
  recipe: state => state.selectedRecipe,
  totalItems: state => state.totalItems,
  error: state => ({ isError: state.isError, message: state.errorMessage })
};
